<template>
  <div class="d-flex flex-column">
<!--    <v-banner two-line>-->
<!--      <v-avatar-->
<!--          slot="icon"-->
<!--          color="white"-->
<!--          style="border: yellow"-->
<!--          size="80"-->
<!--      >-->
<!--        <v-icon-->
<!--            icon="mdi-lock"-->
<!--            color="yellow dark-2"-->
<!--            large-->
<!--        >-->
<!--          mdi-alert-circle-outline-->
<!--        </v-icon>-->
<!--      </v-avatar>-->
<!--      请注意<br/>-->
<!--      <div v-html="warning"></div>-->
<!--      <template v-slot:actions="{ dismiss }">-->
<!--        <v-btn-->
<!--            text-->
<!--            color="primary"-->
<!--            @click="dismiss"-->
<!--        >-->
<!--          关闭-->
<!--        </v-btn>-->
<!--      </template>-->
<!--    </v-banner>-->
    <appointment-list ref="list" :buttonPriviledgeList="buttonPriviledgeList" v-show="formStatus == 'list'" @formCallback="handleFormStatus"></appointment-list>
    <appointment-form :buttonPriviledgeList="buttonPriviledgeList" v-if="formStatus == 'add'" @formCallback="handleFormStatus" :formData="formData"></appointment-form>
    <appointment-view :buttonPriviledgeList="buttonPriviledgeList" v-if="formStatus == 'view'" @formCallback="handleFormStatus" :formData="formData"></appointment-view>
  </div>
</template>

<script>
import AppointmentList from "@/views/appointment/orders/AppointmentList";
import {default as PermissionApi} from "@/api/smp/auth/Permission";
import AppointmentForm from "@/views/appointment/orders/AppointmentForm";
import AppointmentView from "@/views/appointment/orders/AppointmentView";
import {default as ConfigApi} from "@/api/appointment/config/ConfigApi";
export default {
  name: "Appointment-Orders",
  components: {AppointmentView, AppointmentForm, AppointmentList},
  props: {
    page: {
      type: Object,
      default: null,
    }
  },
  data(){
    return {
      formStatus:'list',
      buttonPriviledgeList: [],
      formData:{},
      warning:'',
    }
  },
  created() {
    this.getButtonPriviledge();
    this.getWarning();
  },
  methods: {
    getButtonPriviledge: function () {
      console.log('this.page', this.page)
      let menuId = this.page.id
      let me = this
      PermissionApi.queryButtonPriviledge(menuId, null).then(resp => {
        PermissionApi.handleResponse(resp, me, function (data) {
          me.buttonPriviledgeList = data.buttonPriviledges
          me.success = true;
          console.log('buttonPriviledgeList', me.buttonPriviledgeList)
        })
      })
    },
    handleFormStatus(data){
      this.formStatus = data.formStatus;
      this.formData = data;

      if(this.formStatus == 'list' && data.refresh){
        this.$refs.list.getDataFromApi();
        this.$refs.list.getHasRefund();
      }
    },
    async getWarning() {
      let resp = await ConfigApi.getConfig({name: 'appointment.alert'});
      let data = resp.data;
      if (!data || !data.code || data.code != 200) {
        let msg = data.msg;
        msg = !msg || msg == "" ? "获取配置失败" : msg;
        throw new Error(msg);
      }
      let warning = data.data;
      warning = warning.replaceAll('\n','<br/>');
      this.warning = warning;
    },
  }
}
</script>

<style scoped>

</style>